export const loadReservationDataAction = "Load Reservation Data Action";
export const loadReservationReviewAction = "Load Reservation Revie Data Action";
export const submitReservationAction = "submit new Reservation Action";
export const removePayFailReservationAction =
  "remove PayFail Reservation Action";
